var map = {
	"./custom": 21234,
	"./custom.vue": 21234,
	"./driver.harvesterhci.io": 93041,
	"./driver.harvesterhci.io.vue": 93041,
	"./driver.longhorn.io": 89234,
	"./driver.longhorn.io.vue": 89234,
	"./kubernetes.io/aws-ebs": 92144,
	"./kubernetes.io/aws-ebs.vue": 92144,
	"./kubernetes.io/azure-disk": 70748,
	"./kubernetes.io/azure-disk.vue": 70748,
	"./kubernetes.io/azure-file": 6763,
	"./kubernetes.io/azure-file.vue": 6763,
	"./kubernetes.io/cinder": 48444,
	"./kubernetes.io/cinder.vue": 48444,
	"./kubernetes.io/gce-pd": 20230,
	"./kubernetes.io/gce-pd.vue": 20230,
	"./kubernetes.io/glusterfs": 66589,
	"./kubernetes.io/glusterfs.vue": 66589,
	"./kubernetes.io/no-provisioner": 12220,
	"./kubernetes.io/no-provisioner.vue": 12220,
	"./kubernetes.io/portworx-volume": 30227,
	"./kubernetes.io/portworx-volume.vue": 30227,
	"./kubernetes.io/quobyte": 63340,
	"./kubernetes.io/quobyte.vue": 63340,
	"./kubernetes.io/rbd": 15462,
	"./kubernetes.io/rbd.vue": 15462,
	"./kubernetes.io/scaleio": 7648,
	"./kubernetes.io/scaleio.vue": 7648,
	"./kubernetes.io/storageos": 43072,
	"./kubernetes.io/storageos.vue": 43072,
	"./kubernetes.io/vsphere-volume": 47986,
	"./kubernetes.io/vsphere-volume.vue": 47986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9932;